import Vue from 'vue'
import Router from 'vue-router'
/*引入router*/
Vue.use(Router)
import cookie from 'js-cookie'

/*单个路由*/
const Home = () => import('../studio/Home');
const Login = () => import("../studio/login_logout/login_new_bak");

/*分组路由文件*/
import un_token from './modules/un_token'
import two_d_map_page from './modules/two_d_map_page';/*2维球路由*/
import main_map_page from './modules/main_map_page';/*主地图容器*/
import sub_system_page from './modules/sub_system_page';/*子系统路由*/
import part_cockpit_page from './modules/part_cockpit_page';/*子驾驶舱路由*/

/*处理登录报错函数*/
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
};

let router = new Router({
  routes: [
    {
      path: '/login',
      name: '登录',
      component: Login
    },
    {
      path: '/',
      redirect: '/main_map'
    },
    {
      path: '/',
      name: '系统页面容器',
      component: Home,
      children: [
        ...two_d_map_page,
        ...main_map_page,
      ]
    },

    {
      path: '/',
      name: '子系统页面',
      component: Home,
      children: sub_system_page
    },

    {
      path: '/',
      name: '子驾驶舱页面',
      component: Home,
      children: part_cockpit_page
    },
  ]
});

/*路由验证*/
router.beforeEach((to, from, next) => {
  if (to.path == '/login') {		//如果当前进入页面是登录或继续进入。
    next();
    /*清除登录信息*/
    if(window.vue){
      window.vue.GLOBAL.common_tool.del_user_info()
    }else{
      setTimeout(() => {
        if(window.vue){
          window.vue.GLOBAL.common_tool.del_user_info()
        }
      },300)
    }
  } else {
    let token = cookie.get(sys_token_prefix + "token");
    //let token = window.vue.GLOBAL.common_tool.get_token()
    /*既没有token也不属于非token验证的路由，进入登录页*/
    if (!token && !un_token.some(item => item.path == to.path)) {
      next('/login');
    } else {
      next();
    }
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js